//
import CostCenterModel from '@/models/Accounting/AccCostCenter'
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'
import ProviderBranchOfficeModel from '@/models/Purchase/PchProviderBranchOffices'

//
import DetailPurchaseInvoiceHeaders from '@/views/Purchase/PchPurchaseInvoice/PchDetailPurchaseInvoiceHeaders'

//

export default (providerBranch =[]) => [
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        props: {
            label: 'Proveedor',
            itemText: 'business_name',
            itemValue: 'id',
            model: ProviderModel,
            noObject: true,
            readonly: true,
        },
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'autocomplete',
        props: {
            clearable: true,
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales',
            items: providerBranch,
            noObject: true,
            readonly: true,
            
        },
    },
    {
        name: 'invoice_number',
        type: 'combobox',
        props: {
            chips: true,
            deletableChips: true,
            itemText: 'invoice_number',
            itemValue: 'invoice_number',
            label: 'N° de factura',
            readonly: true,
        },
    },
    {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        props: {
            label: 'Método de pago',
            itemText: 'type',
            itemValue: 'id',
            model: PaymentConditionModel,
            noObject: true,
            paramSearch: 'type',
            readonly: true,
        },
    },
    {
        name: 'emission_date',
        type: 'date-field',
        props: {
            label: 'Fecha emisión',
            fieldProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Fecha pago',
            fieldProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'selected',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            headers: DetailPurchaseInvoiceHeaders,
            noDataText: 'Sin productos.',
            noExport: true,
            noRefresh: true,
            showNativePagination: true,
            toolbarTitle: 'Lista de productos',
        },
    },
    {
        name: 'extra_tax',
        type: 'currency-field',
        props: {
            label: 'Impuesto extra',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'new_subtotal',
        type: 'currency-field',
        props: {
            label: 'Neto',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'iva',
        type: 'currency-field',
        props: {
            label: 'IVA',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'total',
        type: 'currency-field',
        props: {
            label: 'Total',
            readonly: true,
            reverse: true,
        },
    },
    {
        name: 'acc_cost_center_id',
        type: 'autocomplete-model',
        props: {
            label: 'Centro costo',
            itemText: 'name',
            itemValue: 'id',
            model: CostCenterModel,
            noDataText: 'No se encontraron centros de costo.',
            noObject: true,
            paramSearch: 'name',
            readonly: true,
        },
    },
    {
        name: 'is_exent',
        type: 'checkbox',
        props: {
            label: 'Factura exenta',
            readonly: true,
        },
    },
    {
        name: 'payable',
        type: 'checkbox',
        props: {
            falseValue: true,
            label: 'Bloquear pago',
            trueValue: false,
        },
    },
]
